export default {
    SET_NEWS: (state, news) => {
        state.news = news
    },

    EDIT_NEWS: (state, news) => {
        const newsIndex = state.news.findIndex(it => it.id === news.id)
        state.news.splice(newsIndex, 1, news)
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    },

    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },

    RESET_NEWS: (state) => {
        state.filters = {
            fromDate: null,
            toDate: null,
            header: null,
            showTo: null
        }
    }
}
